import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 bg-white border-t border-gray-100" data-id="element-562">
      <div className="max-w-7xl mx-auto text-center" data-id="element-563">
        <span className="text-sm font-bold tracking-widest uppercase text-[#0066FF] mb-6 block font-sans" data-id="element-564">
          Enterprise Wisdom
        </span>

        <h2 className="text-5xl md:text-6xl font-bold mb-8 tracking-tight text-black leading-none max-w-4xl mx-auto font-['Syne']" data-id="element-565">
          You can give an intern the keys to a law library, it won't make them a
          lawyer.
        </h2>

        <div className="text-center mb-12" data-id="element-566">
          <p className="text-xl text-gray-600 mb-4 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-567">
            Synthia is the central nervous system for enterprise
            intelligence—the infrastructure your company uses to move past the
            hype and fix how AI actually works for your business.
          </p>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-568">
            <strong className="text-black font-semibold" data-id="element-569">
              Build your context once. Deploy it everywhere.
            </strong>
          </p>
        </div>

        <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105" data-id="element-570">
          BOOK A DEMO
          <ArrowRight className="w-5 h-5" data-id="element-571" />
        </Link>
      </div>
    </section>;
}